import { render } from "./praRequestDialog.vue?vue&type=template&id=1f522124&scoped=true"
import script from "./praRequestDialog.vue?vue&type=script&lang=js"
export * from "./praRequestDialog.vue?vue&type=script&lang=js"

import "./praRequestDialog.vue?vue&type=style&index=0&id=1f522124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f522124"]])

export default __exports__